import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom';

//Iconos
import DeleteIcons from '@material-ui/icons/Delete'
// import ViewIcons from '@material-ui/icons/Visibility'
//"/assets/dist/svg/main.svg#check"
import { Button, CardActionArea, CardActions, CardContent, CircularProgress, Grid, Divider } from '@material-ui/core';
import f1 from '../../../../assets/dist/svg/main.svg';
import { ObtieneEtapasLogic } from '../../../view-model/Inicio/PostulacionesEstudiante.logic';
import { UpdateEtapaProcesoLogic } from '../../../view-model/EtapasProceso/EtapasProceso.logic';
import { ObtieneListadoDocumentosLogic, InsertarDocumentosLogic, EliminarDocumentosLogic } from '../../../view-model/Documentos/Documentos.logic';
import { Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, InputLabel, Paper, PaperProps } from '@material-ui/core'
import IViewDocumentos from "../../../../presentation/view-interfaces/IViewDocumentos";
import Alert from '@material-ui/lab/Alert/Alert';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded'
import { ObtieneProcesoActualLogic } from '../../../view-model/Parametros/Parametros.logic';
import MensajeToken from '../../../../Components/MensajeToken/MensajeToken';
// import { fi } from 'date-fns/locale';
//import { ObtenerDocumentoLogic } from '../../../view-model/Arancel/Arancel.logic';
//"/assets/dist/svg/main.svg#loading"
//"/assets/dist/svg/main.svg#attach"
type Props = { onClickContinuar: any }
export const ImpresionDocumentos: React.FC<Props> = ({ onClickContinuar }) => {
    const history = useHistory();
    const location = useLocation();
    const Doc: Array<IViewDocumentos> = [];
    const [listaDoc, setListaDoc] = useState(Doc)
    const [idProcesoPostulante, setIdProcesoPostulante] = useState(0);
    // const [validado, setValidado] = useState(0);

    // const [archivo, setArchivo] = useState('')

    const [formatoIncorrecto, setFormatoIncorrecto] = useState(false)
    const [txtformatoIncorrecto, setTxtFormatoIncorrecto] = useState("")
    const [idDocumento, setIdDocumento] = useState(0)

    const [cargandoValores, setCargandoValores] = useState(true)

    const [docSubido, setDocSubido] = useState('')

    const [subiendoDoc, setSubiendoDoc] = useState(false)
    const [eliminandoDoc, setEliminandoDoc] = useState(false)

    const [eliminarDoc, setEliminarDoc] = useState(false)

    const [allUploaded, setAllUploaded] = useState(false)

    const [error, setError] = useState(false)
    const [reintentar, setReintentar] = useState(false)
    const [errorsubida, setErrorSubida] = useState(false)
    const [agnoActual, setAgnoActual] = useState(0)
    const [periodoActual, setPeriodoActual] = useState(0)
    const [errorDoc, setErrorDoc] = useState(false)
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
    const [codNegocio, setCodNegocio] = useState(0)
    // const [cargandoContrato, setCargandoContrato] = useState(false)
    useEffect(() => {
        if (reintentar) {
            setError(false)
            if (location.state === null || location.state === undefined) {
                history.push({
                    pathname: "/Inicio"
                });
            } else {
                handleCargaDatosIniciales();
            }
            setReintentar(false)
        }
    }, [reintentar])

    useEffect(() => {
        if (location.state === null || location.state === undefined) {
            history.push({
                pathname: "/Inicio"
            });

        } else {
            ObtieneProcesoActualLogic(selListaProcesoActual)
            handleCargaDatosIniciales();
        }
    }, [])

    const handleCargaDatosIniciales = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        /* console.log(_params) */
        setCodNegocio(_params.headers.codNegocio)
        setIdProcesoPostulante(Number(_params.idProceso))
        /* console.log(_params.idProceso) */
        ObtieneEtapasLogic(selListaEtapas, _params.codigoNegocio, _params.codCarrera, _params.codigoPlanificacionAcademica, _params.rut, _params.anioPromocion, _params.periodoPromocion);
        /* ObtieneListadoDocumentosLogic(selListaDocumentos, _params.codCarrera, _params.CodigoNegocio) */
        ObtenerListadoDocumentos()
    }
    const ObtenerListadoDocumentos = () => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt);
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        let idPersona = _params.idPeriodo === null ? 0 : _params.idPersona;
        ObtieneListadoDocumentosLogic(selListaDocumentos, _params.headers, _params.codCarrera, _params.codigoNegocio, _params.rut, 'MATWEB', _params.codigoPlanificacionAcademica, idPeriodo, idPersona);
    }
    const InsertarDocumentos = (idDoc: number, extension: string, base64: string) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        let idPeriodo = _params.idPeriodo === null ? 0 : _params.idPeriodo;
        let idPersona = _params.idPeriodo === null ? 0 : _params.idPersona;
        setSubiendoDoc(true)
        setErrorSubida(false)
        /* console.log(_params) */
        /* ObtieneEtapasLogic(selListaEtapas, _params.CodigoNegocio, _params.codCarrera, _params.CodigoPlanificacionAcademica, _params.rut, _params.año, _params.periodo);
         */
        if (agnoActual !== 0 || periodoActual !== 0) {
            InsertarDocumentosLogic(selInsertDocumentos, 1, _params.rut, _params.codCarrera, "MATWEB", idDoc, extension, base64, agnoActual, periodoActual, _params.codigoNegocio, _params.codigoPlanificacionAcademica, idPeriodo, idPersona);
        } else {
            setErrorSubida(true)
            let fecha = new Date()
            setDocSubido(fecha.toString())
            ObtenerListadoDocumentos()
        }
    }
    const selListaProcesoActual = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false) {
                setPeriodoActual(parseInt(data.periodo))
                setAgnoActual(data.ano)
            }
        } catch (err) {
            console.log('error', err)
        }
    }
    const EliminarDocumentos = (doc: any) => {
        let _tt = JSON.stringify(location.state);
        let _params = JSON.parse(_tt)
        setIdDocumento(doc.idDocumento)
        setEliminarDoc(false)
        setEliminandoDoc(true)
        setErrorSubida(false)
        setTimeout(() => {
            EliminarDocumentosLogic(selEliminarDocumentos, _params.rut, _params.codCarrera, doc.idDocumento, doc.anioAlumnoDocumento, doc.periodoAlumnoDocumento)
        }, 2000);


    }
    const selListaEtapas = (error: Boolean, err: string, Etapas: any) => {
        // if (error === false && Etapas !== undefined) {
        //     Etapas.map((e: any) => {
        //         // if (e.idEtapa === 5) {
        //         //     setValidado(e.estado)
        //         // }
        //     })
        // }
    }
    const selInsertDocumentos = (error: Boolean, err: string, result: boolean) => {
        if (error === false && result !== undefined) {
            /*  console.log(result) */
            setErrorSubida(!result)
        } else {
            setErrorSubida(true)
        }
        /* setSubiendoDoc(false) */
        let fecha = new Date()
        setDocSubido(fecha.toString())
        ObtenerListadoDocumentos()
    }
    const selEliminarDocumentos = (error: Boolean, err: string, result: boolean) => {
        // if (error === false && result !== undefined) {
        //     /* console.log(result) */
        // }
        setEliminandoDoc(false)
        ObtenerListadoDocumentos()
    }
    const selListaDocumentos = (error: Boolean, err: string, lista: IViewDocumentos[]) => {
        if (error === false && lista !== undefined) {
            /* console.log(lista) */
            setListaDoc(lista)
            let countSubidos = 0;
            lista.map((e: IViewDocumentos) => {
                if (e.subido) {
                    countSubidos = countSubidos + 1;
                }
            })
            setAllUploaded(lista.length === countSubidos)
            setSubiendoDoc(false)
            setCargandoValores(false)
        } else {
            if (err != "500") {
                setOpenModalToken({ open: true, mnsj: err })
            } else {
                setError(true)
            }
        }
    }
    const UpdateEtapaProceso = () => {
        UpdateEtapaProcesoLogic(selUpdateEtapa, idProcesoPostulante, 5);
    }

    const selUpdateEtapa = (error: Boolean, err: string, data: any) => {
        // if (error === false && data !== undefined) {
        //     /* console.log(data) */
        //     /* onClickContinuar("1") */
        // }
    }
    const getBase64 = (file: any) => {
        return new Promise(resolve => {
            // let fileInfo;
            let baseURL = "";
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                baseURL = reader.result !== null ? reader.result.toString() : '';
                resolve(baseURL);
            };
        });
    };

    const handleFileInputChange = (e: any) => {
        setErrorSubida(false)
        console.log(e.target.files[0]);
        let file: any;

        file = e.target.files[0];
        let extension = file.type.split('/')[1];


        /* console.log(extension) */
        getBase64(file)
            .then(result => {
                file["base64"] = result;
                /* console.log('ID Documento: ' + e.target.name.split('/')[1])
                console.log('Nombre Documento: ' + e.target.name.split('/')[0])
                console.log('Nombre Archivo: ' + file.name)
                console.log('Extension: ' + file.name.split('.')[1])
                console.log('Base64: ' + file.base64.split('base64,')[1]) */
                setIdDocumento(parseInt(e.target.name.split('/')[1]))
                let fecha = new Date()
                /* if (file.name.split('.')[1] === 'pdf' || file.name.split('.')[1] === 'PDF' || file.name.split('.')[1] === 'jpg' || file.name.split('.')[1] === 'JPG') { */

                if (extension === 'pdf' || extension === 'PDF' || extension === 'jpg' || extension === 'JPG' || extension === 'jpeg' || extension === 'JPEG') {
                    if (file.size > 6000000) {
                        setDocSubido(fecha.toString())
                        setFormatoIncorrecto(true)
                        setTxtFormatoIncorrecto("El archivo debe tener un tamaño máximo de 6mb (6.000Kb)")
                    } else {
                        setFormatoIncorrecto(false)
                        InsertarDocumentos(e.target.name.split('/')[1], extension === 'jpeg' || extension === 'JPEG' ? 'jpg' : extension, file.base64.split('base64,')[1])
                    }
                } else {
                    setDocSubido(fecha.toString())
                    setFormatoIncorrecto(true)
                    setTxtFormatoIncorrecto("Formato del documento solo puede ser PDF o JPG")
                }
            })
            .catch(err => {
                console.log(err);
            })

    }

    // const handleVerDocumento = (guid: string) => {
    //     setCargandoContrato(true)
    //     ObtenerDocumentoLogic(selDownloadDoc, guid)
    // }

    const selDownloadDoc = (error: Boolean, err: string, result: any) => {
        if (error === false) {
            setErrorDoc(result.length === 0)
        } else {
            setErrorDoc(true)
        }
        //setCargandoContrato(false)
    }
    return (
        <>
            {
                error ?
                    <div className="site-main__container">
                        <div style={{ textAlign: 'center', marginTop: 100 }}>

                            <ErrorOutlineRounded style={{ fontSize: 50, color: 'red' }} />
                            <br />
                            <a><span>Ocurrió un problema al obtener tus documentos, favor comunicarse con la universidad.</span></a>
                            <br />
                            <Button style={{ border: '1px solid gray' }} onClick={() => setReintentar(true)} color="inherit">Reintentar cargar documentos</Button>
                        </div>
                    </div>
                    :
                    <main className="site-main enrollment">
                        {cargandoValores ?
                            <div className="site-main__container">
                                <div style={{ textAlign: 'center', marginTop: 100 }}>

                                    <CircularProgress disableShrink />
                                    <br />
                                    <a><span>Cargando datos</span></a>

                                </div>
                            </div>
                            :
                            <div className="site-main__container">
                                <div style={{ marginTop: '-3rem', marginBottom: '1rem' }} >
                                    <div style={{ fontSize: '1rem' }}>
                                        <div style={{ display: 'list-item' }} className="enrollment__subtitle">A continuación deberás cargar los documentos solicitados en los formatos PDF o JPG, de lo contrario, no podrás finalizar el proceso de matrícula.</div>
                                    </div>
                                </div>
                                <div className="printing-documents">
                                    <h3 className="printing-documents__title">Documentos</h3>
                                    {/* <p className="printing-documents__description">Todos los documentos deberán estar subidos en formato PDF o JPG. De lo contrario, no podrás finalizar el proceso de matrícula.</p> */}
                                    <form id="form-documents" encType="multipart/form-data">
                                        <table id="table-documents" className=" table">
                                            <tbody>
                                                {listaDoc.map((e: IViewDocumentos) => {
                                                    return (
                                                        <div>
                                                            <Grid container item xs={12} sm={12} md={12} xl={12}>
                                                                <Grid container item xs={12} sm={12} md={12} direction="column" justifyContent="center" alignItems="stretch">
                                                                    <tr id="ci-alumno" className="printing-documents__bloque printing-documents__bloque--done">
                                                                        <td style={{ width: '100%' }} className="printing-documents__download">
                                                                            {
                                                                                e.subido ?
                                                                                    <span><svg className="svg-check-dims"><use xlinkHref={f1 + "#check"}></use></svg>&nbsp;&nbsp;</span>
                                                                                    : ""
                                                                            }
                                                                            <span className="">
                                                                                {e.nombre} {e.nombre.indexOf('Cédula') === -1 ? "" : <a style={{ color: 'gray', fontSize: 14 }} /* className="enrollment__back" */>(El archivo debe incluir ambas caras del documento) </a>}{e.nombre.indexOf('Licencia Enseñanza Media') === -1 ? "" : <a href="https://certificados.mineduc.cl/mvc/home/index" target="_blank" style={{ color: '#0062a1', fontSize: 10 }} /* className="enrollment__back" */>(Descargar LEM)</a>}&nbsp;
                                                                            </span>
                                                                        </td>
                                                                    </tr>
                                                                </Grid>
                                                                {
                                                                    eliminandoDoc && idDocumento === e.idDocumento ?
                                                                        <Grid container item xs={5} sm={5} md={5} direction="column" justifyContent="center" alignItems="stretch">
                                                                            <tr id="ci-alumno" className="printing-documents__bloque printing-documents__bloque--done">
                                                                                <td style={{ width: '100%' }} className="printing-documents__upload">
                                                                                    <div><CircularProgress size={18} disableShrink /> <label>&nbsp;&nbsp;Eliminando Documento.</label></div>
                                                                                </td>
                                                                            </tr>
                                                                        </Grid>
                                                                        :
                                                                        subiendoDoc && idDocumento === e.idDocumento ?
                                                                            <Grid container item xs={5} sm={5} md={5} direction="column" justifyContent="center" alignItems="stretch">
                                                                                <tr id="ci-alumno" className="printing-documents__bloque printing-documents__bloque--done">
                                                                                    <td style={{ width: '100%' }} className="printing-documents__upload">
                                                                                        <div><CircularProgress size={18} disableShrink /> <label>&nbsp;&nbsp;Subiendo Documento.</label></div>
                                                                                    </td>
                                                                                </tr>
                                                                            </Grid>
                                                                            :
                                                                            e.subido ?
                                                                                <Grid container item xs={5} sm={5} md={5} direction="column" justifyContent="center" alignItems="stretch">
                                                                                    <tr id="ci-alumno" className="printing-documents__bloque printing-documents__bloque--done">
                                                                                        <td style={{ width: '100%' }} className="printing-documents__upload">
                                                                                            <label>Documento cargado correctamente.</label>
                                                                                        </td>
                                                                                    </tr>
                                                                                </Grid> :
                                                                                <Grid container item xs={10} sm={10} md={10} direction="column" justifyContent="center" alignItems="stretch">
                                                                                    <tr id="ci-alumno" className="printing-documents__bloque printing-documents__bloque--done">
                                                                                        <td style={{ width: '100%' }} className="printing-documents__upload">
                                                                                            <input
                                                                                                type="file"
                                                                                                key={docSubido}
                                                                                                style={{ width: '100%', fontSize: 13 }}
                                                                                                name={`${e.nombre}/${e.idDocumento}`}
                                                                                                onChange={handleFileInputChange}
                                                                                            />&nbsp;  <a style={{ color: 'gray', fontSize: 10 }}>El archivo debe tener un tamaño máximo de 6mb (6.000Kb)</a>
                                                                                            {
                                                                                                formatoIncorrecto && idDocumento === e.idDocumento ?
                                                                                                    <Alert /* style={{ width: '30rem' }} */ variant="outlined" severity="warning">{txtformatoIncorrecto}{/* Formato del documento solo puede ser PDF o JPG */}</Alert>
                                                                                                    :
                                                                                                    ""
                                                                                            }
                                                                                            {
                                                                                                errorsubida && idDocumento === e.idDocumento ?
                                                                                                    <Alert /* style={{ width: '30rem' }} */ variant="outlined" severity="error"> Se ha producido un error al intentar cargar el documento. </Alert>
                                                                                                    :
                                                                                                    ""
                                                                                            }
                                                                                        </td>
                                                                                    </tr>
                                                                                </Grid>
                                                                }

                                                                {
                                                                    !eliminarDoc ?
                                                                        <Grid container item xs={6} sm={6} md={6} direction="column" /* justifyContent="center" alignItems="stretch" */>
                                                                            {
                                                                                e.subido ?
                                                                                    <tr id="ci-alumno" >
                                                                                        <td style={{ width: '100%', float: 'right' }}>

                                                                                            <DeleteIcons style={{ float: 'right', marginLeft: 20 }} onClick={() => {
                                                                                                setIdDocumento(e.idDocumento)
                                                                                                setEliminarDoc(true)

                                                                                            }} />
                                                                                            {/* {
                                                                                            cargandoContrato ?
                                                                                                <CircularProgress style={{ float: 'right' }} color="inherit" size={20} disableShrink />
                                                                                                :
                                                                                                <ViewIcons style={{ float: 'right' }} onClick={() => {
                                                                                                    handleVerDocumento(e.guidhqb)
                                                                                                }} />
                                                                                        } */}
                                                                                            &nbsp;&nbsp;&nbsp;&nbsp;
                                                                                            {/* <button
                                                                                            className="btn btn-link"
                                                                                            type="button"
                                                                                            style={{ float: 'right', color: 'gray' }}
                                                                                            onClick={() => {
                                                                                                setIdDocumento(e.idDocumento)
                                                                                                setEliminarDoc(true)
                                                                                            }}>
                                                                                            Eliminar
                                                                                        </button> */}
                                                                                        </td>
                                                                                    </tr> : ""
                                                                            }
                                                                        </Grid> :
                                                                        <Grid container item xs={6} sm={6} md={6} direction="column" justifyContent="center" alignItems="stretch">
                                                                            {
                                                                                e.subido ?
                                                                                    <tr id="ci-alumno" className="printing-documents__bloque printing-documents__bloque--done">
                                                                                        <td style={{ width: '100%' }} className="printing-documents__actions">
                                                                                            {
                                                                                                eliminarDoc && idDocumento === e.idDocumento ?
                                                                                                    <Alert variant="outlined" severity="error">
                                                                                                        <div>
                                                                                                            ¿ Está seguro de eliminar este documento ?&nbsp;&nbsp;
                                                                                                            <button style={{ border: '1px solid gray', fontSize: 12 }} className="btn" onClick={() => EliminarDocumentos(e)} >Si</button>
                                                                                                            &nbsp;<button style={{ border: '1px solid gray', fontSize: 12 }} className="btn" onClick={() => setEliminarDoc(false)} >No</button>
                                                                                                        </div>
                                                                                                    </Alert> : ""
                                                                                            }
                                                                                        </td>
                                                                                    </tr> : ""
                                                                            }
                                                                        </Grid>
                                                                }
                                                            </Grid>
                                                            <br></br>
                                                            <br></br>
                                                            <Divider light />
                                                        </div>
                                                    )
                                                })}
                                            </tbody>
                                        </table>
                                        <div className="printing-documents__confirm">
                                            <p className="printing-documents__observation">Estimado/a: Es tu responsabilidad cargar los documentos correctos solicitados en esta etapa.</p>
                                        </div>
                                        <div className="payment-webpay__submit">
                                            <div className="form-group">
                                                <a onClick={() => onClickContinuar("3")} style={{ cursor: 'pointer' }}  /* href="pago-webpay--04.html" */ className="enrollment__back"><svg className="svg-chevron-left-dims"><use xlinkHref={f1 + "#chevron-left"}></use></svg> Volver a Forma de Pago</a>
                                                <label className="submit-btn__label-disabled">Ir a la firma de contrato</label>
                                                <button onClick={() => { onClickContinuar("6"); UpdateEtapaProceso() }} disabled={!allUploaded} className="btn btn-primary" id="btn-submit-enrollment-tariff" type="submit">Continuar</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <Dialog open={errorDoc}
                                    maxWidth={"xl"}
                                    aria-labelledby="draggable-dialog-title">
                                    <DialogContent>
                                        <div style={{ fontFamily: 'sans-serif', textAlign: 'center' }}>
                                            No se encontró el documento en el respositorio.
                                        </div>
                                    </DialogContent>
                                    <DialogActions>
                                        <Button autoFocus onClick={() => {
                                            setErrorDoc(false)
                                        }} color="primary" >Salir</Button>
                                    </DialogActions>
                                </Dialog>
                            </div>}
                    </main>
            }
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={codNegocio}></MensajeToken>
                    :
                    ""
            }
        </>
    )
}
